import { render, staticRenderFns } from "./ReportLiveGeneralView.vue?vue&type=template&id=4c38a493"
import script from "./ReportLiveGeneralView.vue?vue&type=script&lang=js"
export * from "./ReportLiveGeneralView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports